// import { useEffect, useRef } from "react";
// import { signOut } from "firebase/auth";
// import { auth } from "../config/firebaseConfig";

// const AutoLogout: React.FC = () => {
//   const timeoutRef = useRef<NodeJS.Timeout | null>(null);

//   const resetTimer = () => {
//     // Limpa o timer anterior
//     if (timeoutRef.current) clearTimeout(timeoutRef.current);

//     // Define novo timer para 30 minutos (em ms)
//     timeoutRef.current = setTimeout(() => {
//       console.log("Usuário inativo por 30 minutos. Fazendo logout...");
//       signOut(auth);
//     }, 30 * 60 * 1000); // 30 minutos
//   };

//   useEffect(() => {
//     // Eventos que "reiniciam" o timer
//     const events = ["mousemove", "keydown", "click", "scroll"];

//     events.forEach((event) => {
//       window.addEventListener(event, resetTimer);
//     });

//     // Inicia o timer ao montar
//     resetTimer();

//     return () => {
//       // Remove listeners ao desmontar
//       events.forEach((event) => {
//         window.removeEventListener(event, resetTimer);
//       });
//       if (timeoutRef.current) clearTimeout(timeoutRef.current);
//     };
//   }, []);

//   return null; // não precisa renderizar nada
// };

// export default AutoLogout;

import { useEffect, useRef } from "react";
import { signOut } from "firebase/auth";
import { auth } from "../config/firebaseConfig";

const AutoLogout: React.FC = () => {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const resetTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(
      () => {
        // console.log("Usuário inativo por 30 minutos. Fazendo logout...");
        signOut(auth);
      },
      30 * 60 * 1000,
    );
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll"];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer();

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return null;
};

export default AutoLogout;
